import React, { useRef, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  Image,
  TextInput,
  Modal,
  Dimensions,
  Pressable,
} from "react-native";
import moment from "moment";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
import AppColors from "../../Constants/AppColors";

const { width, height } = Dimensions.get("window");
const Header = ({
  selectedDate,
  onPrevMonth,
  onNextMonth,
  showMonths,
  setShowMonths,
  handleMonthSelect,
  showYears,
  setShowYears,
  handleYearSelect,
  setSelectedDate,
}) => {
  const monthText = selectedDate
    ? moment(selectedDate).format("MMMM")
    : moment().format("MMMM");
  const yearText = selectedDate
    ? moment(selectedDate).format("YYYY")
    : moment().format("YYYY");
  const handleHeaderPress = () => {
    setShowMonths(!showMonths);
  };
  const handleHeaderPressYear = () => {
    setShowMonths(false);
    setShowYears(!showYears);
  };
  const selectedYear = selectedDate
    ? moment(selectedDate).year()
    : moment().year();

  const goToPrevYear = () => {
    setSelectedDate((prevDate) => {
      if (prevDate) {
        return moment(prevDate).subtract(1, "year").toDate();
      }
      return null;
    });
  };

  const goToNextYear = () => {
    setSelectedDate((prevDate) => {
      if (prevDate) {
        return moment(prevDate).add(1, "year").toDate();
      }
      return null;
    });
  };

  return (
    <View style={styles.headerContainer1}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <View
          style={{
            flexDirection: "row",

            alignItems: "center",
          }}
        >
          <TouchableOpacity onPress={onPrevMonth}>
            <Image source={AppImages.Left} style={{ width: 40, height: 20 }} />
          </TouchableOpacity>
          <View style={styles.monthYearContainer}>
            <TouchableOpacity
              onPress={handleHeaderPress}
              style={{ flexDirection: "row", alignItems: "center" }}
            >
              <Text style={styles.monthText}>{monthText}</Text>

              <Image source={AppImages.Down} style={{ width: 15, height: 8 }} />
            </TouchableOpacity>
          </View>
          <TouchableOpacity onPress={onNextMonth}>
            <Image source={AppImages.Right} style={{ width: 40, height: 20 }} />
          </TouchableOpacity>
        </View>

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",

            alignItems: "center",
          }}
        >
          <TouchableOpacity onPress={goToPrevYear}>
            <Image
              source={AppImages.Left}
              style={{ width: 40, height: 38 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <View style={styles.monthYearContainer}>
            <TouchableOpacity
              onPress={handleHeaderPressYear}
              style={{ flexDirection: "row", alignItems: "center" }}
            >
              <Text style={styles.yearText}>{yearText}</Text>

              <Image source={AppImages.Down} style={{ width: 15, height: 8 }} />
            </TouchableOpacity>
          </View>
          <TouchableOpacity onPress={goToNextYear}>
            <Image source={AppImages.Right} style={{ width: 40, height: 20 }} />
          </TouchableOpacity>
        </View>
      </View>

      {showMonths && (
        <View style={styles.monthsList}>
          {moment.months().map((month, index) => (
            <TouchableOpacity
              key={index}
              onPress={() => handleMonthSelect(index)}
              style={styles.monthItem}
            >
              <Text
                style={{
                  color: AppColors.white,

                  borderRadius: 5,
                  paddingVertical: 5,
                  paddingHorizontal: 5,
                }}
              >
                {month}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      )}

      {showYears && (
        <ScrollView contentContainerStyle={styles.monthsList}>
          {Array.from(
            { length: 10 },
            (_, index) => selectedYear - 9 + index
          ).map((year) => (
            <TouchableOpacity
              key={year}
              onPress={() => handleYearSelect(year)}
              style={styles.yearItem}
            >
              <Text
                style={{
                  color: AppColors.white,

                  borderRadius: 5,
                  paddingVertical: 5,
                  paddingHorizontal: 5,
                }}
              >
                {year}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      )}
    </View>
  );
};

const CustomCalendarSmall = ({
  InputField_1,
  Dot,
  componentProps,
  placeholder,
}) => {
  const [modal, setmodal] = useState(false);
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const textInputRef = useRef(null);

  const [isDateSelected, setIsDateSelected] = useState(false);

  const onOKPressed = () => {
    if (selectedDay && selectedMonth && selectedYear) {
      // Format the selected date
      const selectedDateText = `${selectedDay} ${selectedMonth} ${selectedYear}`;

      // Update the TextInput value with the selected date
      textInputRef.current.setNativeProps({ text: selectedDateText });
      setIsDateSelected(true);
      setmodal(false);
    } else {
      setIsDateSelected(false);
    }
  };

  // ... Rest of the code ...

  const handleYearSelect = (year) => {
    setSelectedDate((prevDate) => {
      if (prevDate) {
        const newDate = moment(prevDate).year(year).toDate();
        setSelectedDay(newDate.getDate().toString());
        setSelectedMonth(moment(newDate).format("MMMM"));
        setSelectedYear(newDate.getFullYear().toString());
        return newDate;
      }
      return null;
    });
    setShowYears(false);
  };

  const [showMonths, setShowMonths] = useState(false);
  const [showYears, setShowYears] = useState(false);
  const daysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate();
  };
  const [selectedDate, setSelectedDate] = useState(new Date());

  const getMonthData = (month, year) => {
    const firstDay = new Date(year, month - 1, 1);
    const days = daysInMonth(month, year);
    const startingDay = firstDay.getDay();

    const monthData = [];
    let currentDay = 1;

    for (let i = 0; i < 6; i++) {
      const week = [];
      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < startingDay) {
          week.push(null);
        } else if (currentDay > days) {
          week.push(null);
        } else {
          week.push(currentDay);
          currentDay++;
        }
      }
      monthData.push(week);
    }

    return monthData;
  };
  const goToPrev = (unit) => {
    setSelectedDate((prevDate) => {
      if (prevDate) {
        return moment(prevDate).subtract(1, unit).toDate();
      }
      return null;
    });
  };

  const goToNext = (unit) => {
    setSelectedDate((prevDate) => {
      if (prevDate) {
        return moment(prevDate).add(1, unit).toDate();
      }
      return null;
    });
  };

  const handleMonthSelect = (month) => {
    setSelectedDate((prevDate) => {
      if (prevDate) {
        const newDate = moment(prevDate).month(month).toDate();
        setSelectedDay(newDate.getDate().toString());
        setSelectedMonth(moment(newDate).format("MMMM"));
        setSelectedYear(newDate.getFullYear().toString());
        return newDate;
      }
      return null;
    });
    setShowMonths(false);
  };

  const renderCalendar = () => {
    const currentDate = selectedDate || new Date();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const monthData = getMonthData(month, year);

    return monthData.map((week, weekIndex) => (
      <View key={weekIndex} style={styles.weekContainer}>
        {week.map((day, dayIndex) => (
          <TouchableOpacity
            key={dayIndex}
            style={[
              styles.dayContainer,
              day === null && styles.emptyDay,
              selectedDate &&
                currentDate.toDateString() === selectedDate.toDateString() &&
                day === currentDate.getDate() &&
                styles.selectedDay,
            ]}
            onPress={() => {
              if (day) {
                setSelectedDate(new Date(year, month - 1, day));
                setSelectedDay(day.toString());
                setSelectedMonth(
                  moment(new Date(year, month - 1, day)).format("MMMM")
                );
                setSelectedYear(year.toString());
              }
            }}
          >
            {day !== null && (
              <Text
                style={[
                  styles.dayText,
                  day === currentDate.getDate() && styles.selectedDayText,
                ]}
              >
                {day}
              </Text>
            )}
          </TouchableOpacity>
        ))}
      </View>
    ));
  };

  const selectedDateText = selectedDate
    ? {
        day: selectedDay ? selectedDay : placeholder,
        month: selectedMonth ? selectedMonth : "",
        year: selectedYear ? selectedYear : "",
      }
    : {
        day: "Select",
        month: "Date",
        year: "",
      };

  return (
    <View>
      <Modal
        animationType="slide"
        visible={modal}
        onRequestClose={() => {
          setmodal(false);
        }}
        transparent={true}
      >
        <Pressable style={styles.feed}>
          <View style={styles.container}>
            <Header
              selectedDate={selectedDate}
              onPrevMonth={() => goToPrev("month")}
              onNextMonth={() => goToNext("month")}
              showMonths={showMonths}
              setShowMonths={setShowMonths}
              handleMonthSelect={handleMonthSelect}
              showYears={showYears}
              setShowYears={setShowYears}
              handleYearSelect={handleYearSelect}
              setSelectedDate={setSelectedDate}
            />
            <View style={styles.daysHeaderContainer}>
              {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                <Text key={day} style={styles.daysHeaderText}>
                  {day}
                </Text>
              ))}
            </View>
            {renderCalendar()}
            <View
              style={{
                flexDirection: "row",
                justifyContent: "flex-end",
                marginBottom: 20,
                marginHorizontal: 20,
              }}
            >
              <TouchableOpacity
                style={{
                  width: "25%",
                  paddingVertical: 5,
                  borderWidth: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 10,
                  borderColor: "#9C4900",
                }}
                onPress={onOKPressed}
              >
                <Text
                  style={{
                    color: "#9C4900",
                    fontSize: 14,
                    fontFamily: AppFonts.OverpassRegular,
                  }}
                >
                  Cancel
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={{
                  width: "25%",
                  paddingVertical: 5,

                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 10,

                  backgroundColor: "#9C4900",
                  marginLeft: 20,
                }}
                onPress={onOKPressed}
              >
                <Text
                  style={{
                    color: "white",
                    fontSize: 14,
                    fontFamily: AppFonts.OverpassRegular,
                  }}
                >
                  OK
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </Pressable>
      </Modal>
      <View style={{ marginHorizontal: 20 }}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.HeadText}>{InputField_1}</Text>
            <Text style={{ color: "red", marginLeft: 5 }}>{Dot}</Text>
          </View>
          <View style={{}}>{componentProps}</View>
        </View>
        <TouchableOpacity
          onPress={() => setmodal(true)}
          style={[styles.TExtinputView]}
        >
          <TextInput
            editable={false}
            ref={textInputRef}
            placeholder={isDateSelected ? "" : placeholder}
            placeholderTextColor={AppColors.dualbrown}
            value={`${selectedDateText.day} ${selectedDateText.month} ${selectedDateText.year}`}
            style={[styles.TExtinput]}
          />

          <TouchableOpacity
            onPress={() => setmodal(true)}
            style={{
              marginRight: 5,
              alignItems: "flex-end",
              padding: 10,
            }}
          >
            <Image
              source={AppImages.Calender}
              style={styles.Calender}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 20,
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 20,
    alignItems: "center",
  },
  headerContainer1: {
    //justifyContent: "space-between",
    //paddingHorizontal: 20,

    backgroundColor: "#9C4900",
    paddingVertical: 10,
    borderRadius: 10,
    //marginHorizontal:20
  },
  monthYearContainer: {
    alignItems: "center",
    flexDirection: "row",
  },
  monthText: {
    marginRight: 5,
    fontSize: 14,
    color: "white",
    fontFamily: AppFonts.OverpassBold,
  },
  yearText: {
    fontSize: 14,

    marginRight: 5,
    color: "white",
    fontFamily: AppFonts.OverpassBold,
  },
  selectedDayText: {
    fontSize: 14,

    color: "white",
    fontFamily: AppFonts.OverpassBold,
    alignItems: "center",
  },
  arrowText: {
    fontSize: 24,
    fontWeight: "bold",
  },
  daysHeaderContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 10,
    marginBottom: 10,
    marginTop: 20,
  },
  daysHeaderText: {
    fontSize: 16,

    color: "black",
  },
  weekContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 10,
  },
  dayContainer: {
    width: 40,
    height: 40,
    justifyContent: "center",
    alignItems: "center",
  },
  emptyDay: {},
  selectedDay: {
    backgroundColor: "#9C4900",
    borderRadius: 20,
  },
  dayText: {
    fontSize: 16,
    color: "#1C1B1F",
  },
  monthsList: {
    marginTop: 10,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
  },
  monthItem: {
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  yearsList: {
    height: 100,

    justifyContent: "center",
    alignItems: "center",
  },
  yearItem: {
    paddingHorizontal: 8,
    paddingVertical: 4,
  },

  TExtinputView: {
    borderRadius: 8,
    height: 44,
    //backgroundColor: AppColors.sandal,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderWidth: 1,
    borderColor: AppColors.sandal,
    // borderColor:'green',
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "80%",
    //borderRadius: 8,
    color: AppColors.brown2,
    //borderWidth: 1,
    //borderColor: AppColors.red,
    height: 44,
    //
    paddingLeft: 10,
    // backgroundColor: AppColors.sandal,
  },
  Calender: { width: 15, height: 15 },
  HeadText: {
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
  },
  feed: {
    backgroundColor: AppColors.ModalColor,
    flex: 1,
    justifyContent: "center",
  },
});

export default CustomCalendarSmall;
